import { render, staticRenderFns } from "./InvalidFileFormatWindow.vue?vue&type=template&id=31e0d74a&scoped=true"
import script from "./InvalidFileFormatWindow.vue?vue&type=script&lang=js"
export * from "./InvalidFileFormatWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0d74a",
  null
  
)

export default component.exports